<template>
    <div class="dataview-chart-show" :style="displayCss">
        <slot></slot>
    </div>
</template>

<script>
    
    import API from "../../../../Api"

    export default {
              
        data: () => ({
            displayCss: "display:block;",
            cancelToken: null
        }),        
        props:
            {
                chartName: {
                     type: String,
                     required: true
            }
        },
        mounted() {
            //debugger;
            this.CanShowGraph();
        },
        methods: {
            CanShowGraph() {
                
                let url = "dataview/GraphFileExists?name=" + this.chartName + "&id=" + this.$route.params.id;
               
                this.cancelToken = API.CancelToken.source();

                return API.get(url, {
                    cancelToken: this.cancelToken.token
                }).then((res) => {

                    if (res.data) {
                        this.displayCss = 'display:block;';
                    }
                    else {
                        this.displayCss = 'display:none;';
                    }

                    

                    


                }).catch(() => {
                    //TODO error handling here
                    //debugger;
                }).finally(() => {
                    //TODO always do this
                });
            }
        }
    }
</script>
